import {TrinityEvents as Trinity} from '@teaser/scripts/modules/teaser/trinity.js';

export class Slider {
  /** @var {HTMLDivElement|null} element */
  element = null;
  slideCount = 5;
  lastPosition = 0;
  positionRight = 0;
  swipeTrackingInfo = null;

  constructor(slideCount, swipeTrackingInfo, element = null) {
    this.slideCount = slideCount;
    this.swipeTrackingInfo = swipeTrackingInfo;
    this.setElement(element);
  }

  /**
   * @param {HTMLDivElement | null} element
   */
  setElement = (element) => {
    if (element === this.element) return;
    if (this.element) {
      this.element.removeEventListener('scroll', this.updatePosition);
    }
    this.element = element;
    if (this.element) {
      this.updatePosition();
      this.element.addEventListener('scroll', this.updatePosition, {passive: true});
      this.element.addEventListener('scroll', this.sendSlideTrinityEvent, {passive: true});
    }
  };

  slideLeft() {
    /** @var {HTMLElement} */
    const firstChild = this.element.firstElementChild;
    const itemWidth = firstChild.offsetWidth;

    this.element.scrollTo({left: this.element.scrollLeft - itemWidth * this.slideCount, behavior: 'smooth'});
  }

  slideRight() {
    /** @var {HTMLElement} */
    const firstChild = this.element.firstElementChild;
    const itemWidth = firstChild.offsetWidth;

    this.element.scrollTo({left: this.element.scrollLeft + itemWidth * this.slideCount, behavior: 'smooth'});
  }

  updatePosition = () => {
    if (this.element.scrollLeft < 1) {
      this.element.classList.add('-start');
    } else {
      this.element.classList.remove('-start');
    }

    if (this.element.scrollLeft >= this.element.scrollWidth - this.element.clientWidth - 1) {
      this.element.classList.add('-end');
    } else {
      this.element.classList.remove('-end');
    }

    this.lastPosition = this.positionRight;
    this.positionRight =
      Math.round(this.element.scrollLeft / this.element.firstElementChild.offsetWidth) + this.slideCount - 1;
  };

  sendSlideTrinityEvent = () => {
    if (this.lastPosition === this.positionRight) return;

    if (this.positionRight > this.lastPosition) {
      if (this.positionRight % this.slideCount === 0) {
        this.handleSwipe('Right');
      }
    } else if (this.positionRight < this.lastPosition) {
      if ((this.positionRight + 1) % this.slideCount === 0) {
        this.handleSwipe('Left');
      }
    }
  };

  handleSwipe = (clickName) => {
    if (!this.swipeTrackingInfo) return;
    switch (this.swipeTrackingInfo.teaserType) {
      case 'productSlider':
        Trinity.sendProductSliderNextArticles({
          teaserElementId: this.swipeTrackingInfo.teaserElementId,
          shopId: this.swipeTrackingInfo.shopId,
          clickName: this.swipeTrackingInfo.teaserType + clickName,
          page: this.swipeTrackingInfo.page,
          object: 'carousel',
        });
        break;
      case 'topicSlider':
        Trinity.sendTopicSliderNextTopics({
          teaserElementId: this.swipeTrackingInfo.teaserElementId,
          shopId: this.swipeTrackingInfo.shopId,
          clickName: this.swipeTrackingInfo.teaserType + clickName,
          page: this.swipeTrackingInfo.page,
          teaserType: this.swipeTrackingInfo.teaserType,
          object: 'carousel',
        });
        break;
      default:
        return;
    }
  };
}
